import {
    GET_CASES_REQUEST,
    GET_CASES_SUCCESS,
    GET_CASES_FAILURE,
    CHANGE_CASE_STATUS_REQUEST,
    CHANGE_CASE_STATUS_SUCCESS,
    CHANGE_CASE_STATUS_FAILURE,
    GET_CASE_DETAILS_FAILURE,
    GET_CASE_DETAILS_REQUEST,
    GET_CASE_DETAILS_SUCCESS
} from './constants';

const initialState = {
    loading: true,
    cases: [],
    totalNumber: 0,
    statusChange: undefined,
    caseList: [],
    getCaseSuccess: undefined,
    success: false
};

const adminCasesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_CASES_REQUEST: {
            
            return Object.assign({}, state, {loading: false, statusChange: undefined});
        }
        case GET_CASES_SUCCESS: {
            return Object.assign({}, state, {loading: false, statusChange: undefined, cases: action.data.cases, totalNumber: action.data.totalNumber, success: true});
        }
        case GET_CASES_FAILURE: {
            return Object.assign({}, state, {loading: false, statusChange: undefined, cases: [], totalNumber: 0});
        }
        case CHANGE_CASE_STATUS_REQUEST: {
            return Object.assign({}, state, {loading: false, statusChange: undefined, cases: []});
        }
        case CHANGE_CASE_STATUS_SUCCESS: {
            return Object.assign({}, state, {loading: false, statusChange: true, cases: action.data.cases, totalNumber: action.data.totalNumber});
        }
        case CHANGE_CASE_STATUS_FAILURE: {
            return Object.assign({}, state, {loading: false, statusChange: false, cases: [], totalNumber: 0});
        }
        case GET_CASE_DETAILS_REQUEST: {
            return Object.assign({}, state, {loading: false, getCaseSuccess: undefined});
        }
        case GET_CASE_DETAILS_SUCCESS: {
            return Object.assign({}, state, {loading: false, getCaseSuccess: true, caseList: action.data});
        }
        case GET_CASE_DETAILS_FAILURE: {
            return Object.assign({}, state, {loading: false, getCaseSuccess: false,});
        }
        default: {
            return state;
        }
    }
};

export default adminCasesReducer;



// WEBPACK FOOTER //
// ./src/containers/Layouts/Admin/AllCases/reducer.js